<template>
  <div class="checkoutFinish">
    <StepView :active-index="2" :steps="steps"></StepView>
    <finish-page button-caption="К заказам" :exit-route="{name: 'OrdersView'}">
      <template #mainText>
        <span class="checkoutFinish__head">
          {{statusText}}
        </span>
      </template>
      <template #infoText>
        Вы можете  посмотреть детали заказа, а также отслеживать доставку в личном кабинете.
      </template>

    </finish-page>
  </div>
</template>

<script>
import FinishPage from "@/components/shared/FinishPage.vue";
import StepView from "@/components/CartView/StepView.vue";
import {useCartTools} from "@/composables/cart-tools";
import {onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import {useOrdersStore} from "@/store/orders";
import {useToast} from "vue-toast-notification";

export default {
  name: "CheckoutFinishView" ,
  components: {StepView, FinishPage},
  setup() {
    const statusText = ref('Заказ создан');
    const cartTools = useCartTools();
    const ordersStore = useOrdersStore();
    const route = useRoute();
    const toast = useToast()
    onMounted(async () => {
      const orderId = route.query.order_id;
      const res = await ordersStore.checkPayment(orderId)
      if (ordersStore.error) {
        toast.error(ordersStore.error);
        return;
      }
      statusText.value = res;
      toast.success(res);
    });
    return {
      steps: cartTools.cartSteps,
      statusText,
    }
  }
}
</script>


<style scoped lang="scss">
.checkoutFinish {
  &__head {
    font-weight: 500;
    font-size: 36px;
    font-family: var(--cd-bold-font);
  }

}
</style>
